// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatAutoCleanupSettingsPopup__content-b85698 {
  padding: 0 24px;
  flex: 1;
  overflow-y: auto;
}

.ChatAutoCleanupSettingsPopup__tip-fcb505 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
  padding-top: 6px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ChatAutoCleanupSettingsPopup/ChatAutoCleanupSettingsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,gBAAA;AACF","sourcesContent":[".content {\n  padding: 0 24px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.tip {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n  padding-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `ChatAutoCleanupSettingsPopup__content-b85698`,
	"tip": `ChatAutoCleanupSettingsPopup__tip-fcb505`
};
module.exports = ___CSS_LOADER_EXPORT___;
